/**
 * State machine da fila: transições válidas e timeout de processing.
 */

import type { QueueStatus } from '../queue';

export const PROCESSING_TIMEOUT_MS = 30_000;

const VALID_TRANSITIONS: Record<QueueStatus, QueueStatus[]> = {
  queued: ['processing', 'dead'],
  processing: ['sent', 'failed', 'queued', 'dead'],
  failed: ['processing', 'dead', 'queued'],
  sent: [],
  dead: [],
};

export function assertTransition(from: QueueStatus, to: QueueStatus): void {
  const allowed = VALID_TRANSITIONS[from];
  if (!allowed.includes(to)) {
    throw new Error(`Invalid queue transition: ${from} -> ${to}`);
  }
}

export function transitionStatus(
  from: QueueStatus,
  to: QueueStatus
): QueueStatus {
  assertTransition(from, to);
  return to;
}

export function isProcessingTimedOut(
  processingAt: number | undefined,
  now: number,
  timeoutMs = PROCESSING_TIMEOUT_MS
): boolean {
  if (!processingAt) return false;
  return now - processingAt > timeoutMs;
}
